<div class="popover {{ wrapClass }}">
  @if (sort) {
    <div class="row no-gutters pt-3">
      @for (item of sortItems; track item; let i = $index) {
        <button
          stop-propagation
          [ngClass]="{ active: item.active }"
          (click)="setSorting(item)"
          class="rs-btn-link btn sort col-6 fw-700 pb-2">
          {{ item.label | translate }}
        </button>
      }
    </div>
  }
  <div class="item-list">
    @for (item of items; track item; let i = $index) {
      <button
        [disabled]="item.icon"
        role="menuitem"
        (click)="onSelect(item)"
        [ngClass]="{ 'pb-4': items.length !== i + 1, item: !item.icon }"
        class="bg-transparent border-0 outline-none text-left w-full p-0 block cursor-pointer disabled:opacity-50">
        <div>
          <span
            [ngClass]="item.icon || ''"
            class="prefix inline-block w-4 mr-2 align-middle"></span>
          <span
            [ngClass]="{ danger: item.value === 'remove' }"
            class="title font-bold align-middle">
            {{ item.label | translate }}
          </span>
          @if (item.description) {
            <div class="description">{{ item.description }}</div>
          }
        </div>
        @if (separator && items.length !== i + 1) {
          <div class="popover-separator separator-dark mt-3"></div>
        }
      </button>
    }
  </div>
</div>
